import { ELandingTabsEnum } from './config';

export enum ETabKey {
  Basics = 'basics',
  Media = 'media',
  Units = 'units',
  Promotions = 'promotions',
  Specifications = 'specifications',
  Summary = 'summary',
}

export enum EScreenKey {
  Welcome = 'welcome',
  ProjectName = 'project_name',
  Address = 'address',
  ProjectDescription = 'project_description',
  ProjectConstructors = 'project_constructors',
  ProjectGallery = 'project_gallery',
  DealType = 'deal_type',
  DealTypeResidential = 'deal_type_residential',
  ProjectFeatures = 'project_features',
  UnitStructure = 'unit_structure',
  UnitNamesAndFloors = 'unit_names_and_floors',
  UnitApartmentsSpecs = 'unit_apartments_specs',
  Promotions = 'promotions',
  Specifications = 'specifications',
  ProjectSummary = 'project_summary',
}
// aligned with ScreenKey and extras
export enum EPreviewSections {
  // Navbar = 'navbar',
  TopGallery = 'top_gallery',
  ProjectDescription = 'project_description',
  InteractivePanorama = 'interactive_panorama',
  InteractiveView = 'interactive_view',
  Promotions = 'promotions',
  Specifications = 'specifications',
  ProjectGallery = 'project_gallery',
  Address = 'address',
  UnitApartmentsSpecs = 'unit_apartments_specs',
  ProjectConstructors = 'project_constructors',
  OtherProjects = 'other_projects',
}

export type TNavbarPage = {
  key: ELandingTabsEnum;
  label: string;
  previewSectionsKey?: EPreviewSections;
};

export enum ENoteStatus {
  Approved = 'approved',
  Edited = 'edited',
  Rejected = 'rejected',
  Default = 'default',
}

export enum EScreenStatus {
  Default = 'default',
  Approved = 'approved',
  Edited = 'edited',
  Rejected = 'rejected',
}

export type TProjectNoteCreator = {
  id: number;
  name: string;
  email: string;
  avatar: string;
};

export type TProjectNote = {
  id: number;
  projectId: number;
  screenKey: EScreenKey;
  content: string;
  status: ENoteStatus;
  createdBy: number;
  readBy: number[];
  createdAt: string;
  updatedAt: string;
  edited: boolean;
  creator: TProjectNoteCreator;
};
